import { isPropValid, media, styled } from '../../../styled-components';
const freePropKeys = ['background', 'boxShadow', 'transition', 'display', 'flexDirection', 'flexWrap', 'flex', 'alignItems', 'justifyContent', 'position', 'top', 'right', 'bottom', 'left', 'overflow', 'cursor', 'pointerEvents'];
const themedPropKeys = ['padding', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft', 'margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'borderRadius'];
const specialPropKeys = ['paddingX', 'paddingY', 'marginX', 'marginY'];
const camelToKebab = value => {
  return value.replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, '$1-$2').toLowerCase();
};
const printResponsiveProp = (props, prop, index) => {
  const normalizedProp = typeof props[prop] === 'string' ? [props[prop]] : props[prop];
  return normalizedProp && normalizedProp[index] ? `${camelToKebab(prop)}: ${normalizedProp[index]};` : null;
};
const mapThemePartial = prop => {
  switch (prop) {
    case 'borderRadius':
      return 'borderRadiuses';
    default:
      return 'spacings';
  }
};
const printResponsiveThemedProp = (props, prop, index) => {
  const normalizedProp = typeof props[prop] === 'string' ? [props[prop]] : props[prop];
  return normalizedProp && normalizedProp[index] ? ({
    theme
  }) => `${camelToKebab(prop)}: ${theme[mapThemePartial(prop)][normalizedProp[index]]};` : null;
};
const mapSpecialProp = (prop, value) => {
  switch (prop) {
    case 'paddingX':
      return `padding-left: ${value}; padding-right: ${value};`;
    case 'paddingY':
      return `padding-top: ${value}; padding-bottom: ${value};`;
    case 'marginX':
      return `margin-left: ${value}; margin-right: ${value};`;
    default:
      return `margin-top: ${value}; margin-bottom: ${value};`;
  }
};
const printResponsiveSpecialProp = (props, prop, index) => {
  const normalizedProp = typeof props[prop] === 'string' ? [props[prop]] : props[prop];
  return normalizedProp && normalizedProp[index] ? ({
    theme
  }) => `${mapSpecialProp(prop, theme.spacings[normalizedProp[index]])}` : null;
};
export const buildStylesArray = (props, index) => {
  const responsiveProps = Object.keys(props).filter(key => {
    return themedPropKeys.includes(key);
  }).map(key => {
    return printResponsiveThemedProp(props, key, index);
  }).filter(styleString => !!styleString); // Remove falsy values

  const specialProps = Object.keys(props).filter(key => specialPropKeys.includes(key)).map(key => printResponsiveSpecialProp(props, key, index)).filter(styleString => !!styleString); // Remove falsy values

  const freeProps = Object.keys(props).filter(key => freePropKeys.includes(key)).map(key => printResponsiveProp(props, key, index)).filter(styleString => !!styleString); // Remove falsy values

  return [...responsiveProps, ...specialProps, ...freeProps];
};
export const Box = styled.div.withConfig({
  shouldForwardProp: isPropValid
})`
  box-sizing: border-box;
  list-style: none;
  padding: 0;
  margin: 0;
  ${props => buildStylesArray(props, 0)}

  ${media.tabletAndUp`
    ${props => buildStylesArray(props, 1)}
  `}

  ${media.tabletWideAndUp`
    ${props => buildStylesArray(props, 2)}
  `}

  ${media.desktopAndUp`
    ${props => buildStylesArray(props, 3)}
  `}

  ${media.largeDesktop`
    ${props => buildStylesArray(props, 4)}
  `}

  /* IE11 hack to make text truncation work in flexbox children */
  > * {
    min-width: 0%;
  }
`;